import { useRef, useEffect, useState } from "react";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import {
  renderThumb,
  renderTrack,
  renderView,
  renderViewMini,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes";
import Card from "components/card";

function SidebarHorizon(props: {
  open: boolean;
  onClose: () => void;
  variant?: string;
  [x: string]: any;
}) {
  const { open, onClose, mini, hovered } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 1200 ? true : false
  );

  useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setIsMobile(true) : setIsMobile(false)
    );
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (open && isMobile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose, isMobile]);

  return (
    <div
      ref={ref}
      className={` sm:none duration-175 linear fixed !z-50 min-h-full w-[285px] transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "" : "-translate-x-[105%]"
      } ${
        mini === false
          ? ""
          : mini === true && hovered === true
          ? ""
          : "xl:!w-[120px]"
      }`}
    >
      <Card
        extra={`ml-3 w-full h-[96.5vh] sm:mr-4 sm:my-4 m-7 !rounded-[20px]`}
      >
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={
            mini === false
              ? renderView
              : mini === true && hovered === true
              ? renderView
              : renderViewMini
          }
        >
          <div className="flex h-full flex-col justify-between">
            <div>
              <span
                className="absolute right-4 top-4 block cursor-pointer xl:hidden"
                onClick={onClose}
              >
                <HiX />
              </span>
              <div className={`ml-[52px] mt-[44px] flex items-center `}>
                <div
                  className={`ml-1 mt-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white ${
                    mini === false
                      ? "block"
                      : mini === true && hovered === true
                      ? "block"
                      : "hidden"
                  }`}
                >
                  Agent <span className="font-medium">IQ</span>
                </div>
                <div
                  className={`ml-1 mt-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white ${
                    mini === false
                      ? "hidden"
                      : mini === true && hovered === true
                      ? "hidden"
                      : "block"
                  }`}
                >
                  A
                </div>
              </div>
              <div className="mb-7 mt-[58px] h-px bg-gray-200 dark:bg-white/10" />
              <ul>
                <Links
                  mini={mini}
                  hovered={hovered}
                  routes={routes}
                  onClose={isMobile ? onClose : undefined}
                />
              </ul>
            </div>
            {/* <div className="flex flex-col items-center justify-center ">
              <SidebarCard mini={mini} hovered={hovered} />
            </div> */}
          </div>
        </Scrollbars>
      </Card>
    </div>
  );
}

export default SidebarHorizon;
